export const displayConsoleMessages = () => {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  // ASCII art logo
  const asciiArt = `
   _____  _    _ _    _ __  __ _    _ _   _  ______      __
  / ____|| |  | | |  | |  \\/  | |  | | \\ | |/ __ \\ \\    / /
 | (___  | |__| | |  | | \\  / | |  | |  \\| | |  | \\ \\  / / 
  \\___ \\ |  __  | |  | | |\\/| | |  | | . \` | |  | |\\ \\/ /  
  ____) || |  | | |__| | |  | | |__| | |\\  | |__| | \\  /   
 |_____/ |_|  |_|\\____/|_|  |_|\\____/|_| \\_|\\____/   \\/    
                                                           
  `;

  const primaryColor = isDarkMode ? '#FF5733' : '#0066CC';
  const secondaryColor = 'white';

  // Main title
  console.log(
    `%c${asciiArt}`,
    `color: ${primaryColor}; font-family: monospace; font-size: 10px; font-weight: bold;`
  );

  console.log(
    '%cWelcome to Shumunov Solutions!',
    `color: ${primaryColor}; font-family: system-ui; font-size: 2rem; font-weight: bold; ${!isDarkMode ? '-webkit-text-stroke: 1px white;' : ''}`
  );

  console.log(
    "%cYou're advanced to be looking here, email us at info@shumunovsolutions.com if you'd like to work together, or say hello!",
    `color: ${secondaryColor}; font-family: system-ui; font-size: 1rem; font-style: italic;`
  );

  // Add a styled table with tech stack info
  console.log(
    '%cOur Tech Stack:',
    `color: ${primaryColor}; font-size: 1.2rem; font-weight: bold;`
  );
  // TODO: Match to tech stack on services page
  console.table({
    Frontend: 'React, React Native, Vue, CSS, SCSS, Tailwind',
    Backend: 'Node.js, Express, Python',
    Deployment: 'CI/CD Pipeline',
    Testing: 'Jest, React Testing Library, Vitest',
  });
};
